/**
 * Community verified badge — renders inline next to a name.
 * Usage: <span>Username <VerifiedBadge /></span>
 * Or:    <VerifiedBadge show={user.community_verified} />
 */
const VerifiedBadge = ({ show = true, size = 14, className = '' }) => {
  if (!show) return null;
  return (
    <img
      src="/verified-badge.png"
      alt="Verified"
      className={`inline-block shrink-0 ${className}`}
      style={{ width: size, height: size }}
      data-testid="verified-badge"
      draggable={false}
    />
  );
};

export default VerifiedBadge;
